import { Path, Svg } from "@react-pdf/renderer";
import React from "react";

interface Props {
    fill: string;
}

const Left_Double_Chevron: React.FC<Props> = ({ fill }) => {
    return (
        <Svg width={"12pt"} height={"100%"} fill={fill} viewBox="0 0 24 24">
            <Path d="M 10.036 5.984 C 9.659 5.985 9.315 6.198 9.146 6.534 C 8.899 7.026 9.096 7.624 9.586 7.874 L 17.796 11.984 L 9.586 16.094 C 8.875 16.39 8.751 17.344 9.363 17.812 C 9.689 18.061 10.134 18.085 10.486 17.874 L 20.486 12.874 C 21.171 12.523 21.219 11.562 20.573 11.144 C 20.545 11.126 20.516 11.109 20.486 11.094 L 10.486 6.094 C 10.348 6.02 10.193 5.982 10.036 5.984 Z" />
            <Path d="M 4.036 5.982 C 3.659 5.983 3.315 6.196 3.146 6.532 C 2.899 7.024 3.096 7.622 3.586 7.872 L 11.796 11.982 L 3.586 16.092 C 2.875 16.388 2.751 17.342 3.363 17.81 C 3.689 18.059 4.134 18.083 4.486 17.872 L 14.486 12.872 C 15.171 12.521 15.219 11.56 14.573 11.142 C 14.545 11.124 14.516 11.107 14.486 11.092 L 4.486 6.092 C 4.348 6.018 4.193 5.98 4.036 5.982 Z" />
        </Svg>
    );
};

export default Left_Double_Chevron;
